import { render, staticRenderFns } from "./SingleMatch.vue?vue&type=template&id=24aa4eb4&scoped=true&"
import script from "./SingleMatch.vue?vue&type=script&lang=js&"
export * from "./SingleMatch.vue?vue&type=script&lang=js&"
import style0 from "./SingleMatch.vue?vue&type=style&index=0&id=24aa4eb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aa4eb4",
  null
  
)

export default component.exports